export const setSmsInfo = (state, payload) => {
  if (payload !== undefined || payload !== null) {
    state.smsCreatedInfo = payload;
  }
};

export const setPersistedState = (state, payload) => {
  if(payload.userRetries) {
    state.validationSmsData.userRetries = payload.userRetries;
  }
  state.validationSmsData.createdAt = payload.createdAt;
  state.validationSmsData.lastUpdate = payload.lastUpdate;
  state.validationSmsData.userFailAttemps = payload.userFailAttemps;
  state.validationSmsData.timesValidationFail = payload.timesValidationFail;

}

export const setInitialSmsState = (state, payload) => state.validationSmsData = payload;

export const setOtpValidatedData = (state, payload) => state.smsCreatedInfo = payload;

export const setSmsValidated = (state, payload) => state.smsValidated = payload;

export const setUserNotFound = (state, payload) => state.userNotFound = payload;

export const setUserIsBlocked = (state, payload) => {
  state.userIsBlocked = payload;
  state.userNotFound = !payload
}
